import VerticalRule from './VerticalRule'
export default VerticalRule